export default __webpack_public_path__ + "static/media/error-circle-red.0073040f.svg";